import * as constants from '../constants/constants';

const defaultStore = {
  PDFUrl: false,
  PDFError: false,
  showRewritePopup: '',
  rewriteAnswer: '',
  users: [],
  isUsersDataLoading: false,
  dishes: [],
  isLoadDishes: false,
  userId: '',
  userSuccess: false,
  selectedDate: new Date(),
  user: {},
  isUserDataLoading: false,
  // RecipeModal in MenuBlock
  isOpenRecipeModal: false,
  modalRecipeData: null,
  isDishReadyToUpgrade: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'SET_SELECTED_DATE':
      return {
        ...state,
        selectedDate: action.data,
      };

    case 'GET_DISHES_SUCCESS':
      return {
        ...state,
        dishes: action.data,
      };
    case 'SET_DISH_READY_TO_UPGRADE':
      return {
        ...state,
        isDishReadyToUpgrade: true,
      };
    case 'SET_DISH_UPGRADE':
      return {
        ...state,
        isDishReadyToUpgrade: false,
      };

    case constants.TOGGLE_IS_USERS_DATA_LOADING:
      return {
        ...state,
        isUsersDataLoading: !state.isUsersDataLoading,
      };

    case 'GET_USERS_SUCCESS':
      return {
        ...state,
        users: action.data,
        userUpdated: false,
        userSuccess: true,
        isUsersDataLoading: false,
      };

    case 'UPDATE_USER_DATA_SUCCESS':
      return {
        ...state,
        userUpdated: action.data,
        userSuccess: true,
      };

    case 'SELECT_USER':
      return {
        ...state,
        userId: action.data,
        PDFUrl: false,
        PDFError: false,
      };

    case 'SHOW_REWRITE_REQUEST_POPUP':
      return {
        ...state,
        showRewritePopup: action.data,
      };

    case 'AGREED_SUCCESS':
      return {
        ...state,
        rewriteAnswer: action.data,
        PDFUrl: false,
        PDFError: false,
      };

    case 'GET_PDF_SUCCESS':
      return {
        ...state,
        PDFUrl: action.payload.link,
        PDFError: false,
      };

    case 'CLEAR_AFTER_GET_PDF':
      return {
        ...state,
        PDFUrl: false,
        PDFError: false,
      };

    case 'GET_PDF_ERROR':
      return {
        ...state,
        PDFUrl: false,
        PDFError: true,
      };

    case 'CLEAR_PDF_LINK':
      return {
        ...state,
        PDFUrl: false,
        PDFError: false,
      };

    case 'GENERATE_MENU_SUCCESS':
      return {
        ...state,
        PDFUrl: false,
        PDFError: false,
      };
    case 'SEND_FILTERS_SUCCESS':
      return {
        ...state,
        dishes: action.data,
      };
    case constants.TOGGLE_LOAD_DISHES:
      return {
        ...state,
        isLoadDishes: !state.isLoadDishes,
      };
    case 'USER_TO_PROPS':
      return {
        ...state,
        user: action.user,
      };
    case constants.TOGGLE_USER_DATA_LOADING:
      return {
        ...state,
        isUserDataLoading: !state.isUserDataLoading,
      };
    // RecipeModal actions
    case constants.CLOSE_RECIPE_MODAL:
      return {
        ...state,
        modalRecipeData: null,
        isOpenRecipeModal: false,
      };
    case constants.OPEN_RECIPE_MODAL:
      return {
        ...state,
        modalRecipeData: action.payload.modalRecipeData,
        isOpenRecipeModal: true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reducers.js